import React from 'react';
import ShopSection from '../ShopSection';


function ShopPage() {
  return (
    <div className="page shop-page halftone-light">
      <ShopSection />

    </div>
  );
}

export default ShopPage;
